import React, { useEffect, useState } from 'react';
import Popup from '../Popup/BasePopup';
import Button from '../CommonFields/Button';
import TextInput from '../CommonFields/TextInput';

const CallbackMobile = ({ onMobileNo, isOpen, onClose, title }) => {
  const [mobileNo, setMobileNo] = useState(
    JSON.parse(localStorage.getItem('profile'))?.phone || ''
  );
  const [error, setError] = useState('');

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, ''); // Allow only digits
    setMobileNo(value);

    // Validate the mobile number length
    if (value.length !== 10) {
      setError('Mobile number must be 10 digits long');
    } else {
      setError('');
    }
  };

  const handleNextClick = () => {
    if (mobileNo.length === 10) {
      onMobileNo(mobileNo);
    } else {
      setError('Mobile number must be 10 digits long');
    }
  };

  return (
    <Popup isOpen={isOpen} onClose={onClose} title={title}>
      <div>
        <TextInput
          labelName={"Mobile Number"}
          inputLength={"10"}
          placeholder={""}
          value={mobileNo}
          onChange={handleMobileChange}
          helperText={error}
        />
      </div>
      <div className='mb-4 mt-4'>
        <p className='f-12 text-subscription ps-3 my-2'>
          You will receive a call back on the entered number
        </p>
        <Button text={"Next"} onClick={handleNextClick} />
      </div>
    </Popup>
  );
};

export default CallbackMobile;
